import React, { useRef, useEffect, useState } from 'react';
import './App.css';
import Footer from './Footer';

const images = [
  './images/Harbin.webp',
  './images/habin1.webp',
  './images/habin2.webp',
  './images/habin3.webp',
];

const TravelForm = () => {
  const carouselRef = useRef(null);
  const [lang, setLang] = useState('en');

  useEffect(() => {
    const scrollInterval = setInterval(() => {
      if (carouselRef.current) {
        const container = carouselRef.current;
        const maxScrollLeft = container.scrollWidth - container.clientWidth;

        if (container.scrollLeft >= maxScrollLeft) {
          container.scrollLeft = 0;
        } else {
          container.scrollLeft += 260;
        }
      }
    }, 2000);

    return () => clearInterval(scrollInterval);
  }, []);

  const content = {
    en: `Harbin, the capital of Heilongjiang Province in northeastern China, is famous for its Russian-style architecture, winter wonderland charm, and spectacular Ice and Snow Festival.

Top places to visit:

• Harbin Ice and Snow World – A magical city of illuminated ice sculptures and snow castles.
• Saint Sophia Cathedral – A beautiful Russian Orthodox church turned museum.
• Central Street (Zhongyang Dajie) – A pedestrian street lined with European-style buildings, shops, and cafes.
• Sun Island Scenic Area – A riverside park known for snow art and scenic relaxation.
• Siberian Tiger Park – A rare chance to see Siberian tigers roaming in a protected setting.
• Harbin Polarland – A popular marine park featuring polar animals and performances.
• Harbin Snow Sculpture Art Expo – Massive snow sculptures displayed each winter at Sun Island.
• Heilongjiang Provincial Museum – A collection of regional history, natural exhibits, and folk artifacts.
• Harbin Grand Theatre – A modern architectural marvel hosting performances and concerts.
• Songhua River Ice Activities – Enjoy skating, dog sledding, and ice biking in the winter months.

Harbin blends Eastern and Russian influences and becomes a snowy fairy tale during winter, making it one of China’s most unique and festive cities.`,

    zh: `哈尔滨是中国东北的黑龙江省省会，以欧式建筑、冬季奇景和冰雪节闻名，是“东方小巴黎”。

推荐景点：

• 哈尔滨冰雪大世界 – 冰灯雪雕世界，夜晚灯光璀璨，美轮美奂。
• 圣索菲亚教堂 – 俄罗斯风格东正教堂，现为建筑艺术博物馆。
• 中央大街 – 欧式建筑林立的步行街，街边商店和咖啡馆充满异国风情。
• 太阳岛风景区 – 松花江畔的自然公园，适合观雪和散步。
• 东北虎林园 – 近距离观察东北虎的保护区，极具震撼。
• 哈尔滨极地馆 – 以北极动物为特色的海洋公园，有海狮、企鹅表演。
• 太阳岛雪雕艺术博览会 – 每年冬季举办的大型雪雕展览。
• 黑龙江省博物馆 – 展示自然历史和地方文化的综合性博物馆。
• 哈尔滨大剧院 – 外形现代，常有高水平的演出与展览。
• 松花江冰上活动 – 冬季可体验滑冰、狗拉雪橇、冰上自行车等娱乐项目。

哈尔滨冬季如童话世界般梦幻，融合中俄文化，是感受北方冬天魅力的理想之地。`
  };

  return (
    <div className="travel-form-container2">
      {/* Row 1 - Description */}
      <div className="row row-one2">
        <div className="col image-col2">
          <img src="./images/habin2.webp" className="travel-image2" />
          <img src="./images/habin3.webp" className="travel-image2" />
        </div>

        <div className="col content-col2">
          <h2>Harbin</h2>

          {/* Language Toggle Button */}
          <div style={{ textAlign: 'right', marginBottom: '10px' }}>
            <button
              onClick={() => setLang(lang === 'en' ? 'zh' : 'en')}
              style={{
                padding: '8px 16px',
                borderRadius: '6px',
                border: 'none',
                backgroundColor: '#967969',
                color: 'white',
                cursor: 'pointer'
              }}
            >
              {lang === 'en' ? '切换到中文' : 'Switch to English'}
            </button>
          </div>

          {/* Paragraph */}
          <p style={{ whiteSpace: 'pre-line' }}>{content[lang]}</p>
        </div>
      </div>

      {/* Row 2 - Auto Carousel */}
      <div className="carousel-container2">
        <div className="carousel-heading-column">
          <h2 className="carousel-heading">Explore Harbin</h2>
          <p className="carousel-subheading">
            Stroll icy boulevards, admire snowy cathedrals, and witness glowing ice palaces.
          </p>
        </div>

        <div className="carousel2" ref={carouselRef}>
          {images.map((imgSrc, index) => (
            <img key={index} src={imgSrc} className="carousel-image2" />
          ))}
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default TravelForm;
